import React, { useEffect, useState } from 'react';
import './blog.css';
import axios from 'axios';
import BlogItem from '../BlogItem/BlogItem';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const url = process.env.REACT_APP_BASE_URL

  const getAllBlogs = async () => {
    try {
      const response = await axios.get(`${url}/api/blog/list`);
      setBlogs(response.data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch blogs.');
    }
  };

  const deleteBlog = async (id) => {
    // console.log("here is the id ", id);
    try {
      const response = await axios.delete(`${url}/api/blog/remove/${id}`);
      if (response.data.success) {
        setBlogs(blogs.filter((blog) => blog._id !== id));
        toast.success("Blog Deleted Successfully");
      } else {
        // toast.error('Failed to delete blog.');
      }
    } catch (error) {
      // console.error('Error deleting blog:', error);
      toast.error('Error occurred while deleting blog.');
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  return (
    <>
      <div className="blog-container">
        <div className="blog-header">
          <h2>All Blogs</h2>
          <Link to="/admin/dashboard/add-blog" className="add-blog-button">Add Blog</Link>
        </div>
        <div className="blog-item-container">
          {blogs.map((item) => (
            <BlogItem
              key={item._id}
              id={item._id}
              image={`${url}/images/${item.image}`}  // Correct image path
              title={item.title}
              description={item.description.substring(0, 60) + '...'}
              created={item.created}
              handleDelete={deleteBlog}
            />
          ))}
        </div>
      </div>
     
    </>
  );
};

export default Blog;